import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Button } from 'reactstrap';
import isFunction from 'lodash/isFunction';

import OtpInput from '../../../shared/components/otp-input';
import Loader from '../../../shared/components/loader';
import config from '../../../shared/services/config';

import {
  sendOtp,
  verifyOtp,
  resetVerifyOtp,
  setPassword,
  fetchOrCreatePlatformUser,
} from '../../../shared/actions/auth';

import AuthManager from '../../../shared/services/AuthManager';
import { classNames } from '../../../shared/services/utils';

import cleverTap from '../../../shared/services/cleverTap';
import * as AuthEvents from '../../../shared/constants/cleverTapEvents';

import User from '../../models/user';
import { UserResponse, userFriendlyErrorMessage} from '../../../shared/utils/response';

class OTPVerify extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
      state: PropTypes.object,
    }).isRequired,
    otpData: PropTypes.shape({
      data: PropTypes.object,
      fetching: PropTypes.bool,
      success: PropTypes.bool,
      error: PropTypes.array,
    }).isRequired,
    pageHeading: PropTypes.string,
    forMobile: PropTypes.bool,
    skipAllowed: PropTypes.bool,
  };

  static defaultProps = {
    pageHeading: '',
    forMobile: false,
    skipAllowed: false,
  };

  state = {
    isDisabled: true,
    isLoading: false,
    doRedirect: false,
    disbleResendOtp: false,
    errors: [],
    disableVerify: false,
  };

  createParams() {
    const { state: historyState } = this.props.location;
    let { userEmail, userMobile, newUser, user, allowSkip } = historyState;
    userEmail = userEmail || user.email;
    userMobile = userMobile || user.mobile;
    this.userEntity = this.props.forMobile ? userMobile : userEmail;
    this.fullToken = AuthManager.getFullToken();
    // store fullTokenData because it will be needed after verifying email or mobile type Otp
    this.fullTokenData = JSON.parse(window.localStorage.getItem('tempToken'));
    this.allowSkipping =
      !this.props.forMobile && this.props.skipAllowed;
    this.allowSkipping = allowSkip !== undefined ? allowSkip : this.allowSkipping;
    // removing token if email not verified
    // so that user cannot access dashboard without email verification
    if (!this.allowSkipping) {
      AuthManager.removeFullToken();
    }
    if (!historyState) {
      this.props.history.replace('/account');
    } else if (this.fullToken) {
      userEmail =
        userEmail || new User(UserResponse(this.props.hubUser.data)).email;
      userMobile =
        userMobile || new User(UserResponse(this.props.hubUser.data).mobile);
      const params = {
        token: this.fullToken,
        identity: this.props.forMobile ? userMobile : userEmail,
        type: this.props.forMobile ? 'MobileVerification' : 'EmailVerification',
      };
      this.params = params;
      return;
    } else {
      if (newUser && this.props.hubUser && this.props.hubUser.data) {
        const newUserData = new User(UserResponse(this.props.hubUser.data));
        this.accessToken = newUserData.getLimitedAccessToken();
        let params = {
          channels: this.props.forMobile ? ['sms'] : ['email'],
          token: this.fullToken || this.accessToken,
          type: 'SignIn',
          identity: newUserData.id || historyState.user.id,
          scope: config.get('loginScope', ''),
        };
        this.params = params;
        return;
      }
      this.accessToken = historyState.accessToken;
      let params = {
        token: this.fullToken || this.accessToken,
        channels: this.props.forMobile ? ['sms'] : ['email'],
        type: 'SignIn',
        identity: historyState.user.id,
        scope: config.get('loginScope', ''),
      };
      if (this.fullToken) {
        params = {
          ...params,
          token: this.fullToken,
          identity: this.userEntity,
          type: this.props.forMobile
            ? 'MobileVerification'
            : 'EmailVerification',
        };
      }
      this.params = params;
    }
  }

  async componentWillMount() {
    const { state: historyState } = this.props.location;
    this.createParams();
    this.setState({ isLoading: true });
    await sendOtp(this.props.dispatch, {
      ...this.params,
      additional_payload: {
        name: historyState.displayName,
      },
    });
    setTimeout(() => this.setState({ isLoading: false }), 2000);
  }

  componentWillReceiveProps(nextProps) {
    const locationData = nextProps.location.state;
    if (this.props.otpData !== nextProps.otpData) {
      if (nextProps.otpData.success) {
        this.props.dispatch(resetVerifyOtp());
        if (nextProps.otpData.data.access_token) {
          if (locationData.newUser) {
            cleverTap.event(AuthEvents.CREATE_ACCOUNT_SUCCESSFULL);
          }
        }
      }
    }
    if (this.props.otpData !== nextProps.otpData && nextProps.otpData.error) {
      cleverTap.event(AuthEvents.OTP_VERIFICATION_ERROR, {
        OTPChannel: this.props.forMobile ? 'sms' : 'email',
        Email: locationData.userEmail,
        Error: nextProps.otpData.error.toString(),
        Type: locationData.newUser ? 'CreateAccount' : 'Login',
      });
    }
    if (this.props.otpData !== nextProps.otpData && nextProps.otpData.error && nextProps.otpData.error.includes('already_verified')) {
      this.setState({ disableVerify: true });
    }
    if (this.props.otpData !== nextProps.otpData && nextProps.otpData.error && nextProps.otpData.error.includes('is verified.')) {
      this.setState({ isDisabled: true });
    }
  }

  getRedirectLocation() {
    const { state: historyState } = this.props.location;
    return {
      pathname: historyState.redirectTo.shift(),
      state: {
        ...historyState,
      },
    };
  }

  handleSubmit = async e => {
    e.preventDefault();
    const params = {
      token: this.params.token,
      identity: this.params.identity,
      type: this.params.type,
      code: this.otpInputElement.getValue(),
    };
    this.setState({ errors: [] })
    try {
      await verifyOtp(this.props.dispatch, params);
      const { state: historyState } = this.props.location;
      /**
       * set fullTokenData again in localStorage because before verifying email OTP fullTokenData is removed
       * and on verifying email fullTokenData is not received from HUB verify OTP call
       * before this only access_token was set but now token expiry time and other attributes are also needed
       * so set fullTokenData instead of only accessToken
       */
      AuthManager.persistFullToken(this.fullTokenData);
      if (historyState.shiftUuid) {
        const loginRedirectUrl = config.get('loginRedirectUrl');
        const { user, userEmail } = historyState;
        const email = user.email || userEmail;
        await fetchOrCreatePlatformUser(this.props.dispatch, { email, can_create: false }, user.id);
        AuthManager.setAppToken();
        if (isFunction(loginRedirectUrl)) {
          loginRedirectUrl(AuthManager.getUser(), true);
        } else {
          this.props.history.push({
            pathname: loginRedirectUrl,
          });
        }
        return;
      }
      if (
        this.props.forMobile &&
        historyState.password &&
        !historyState.user.isPasswordSet
      ) {
        const setPasswordPromise = setPassword(this.props.dispatch, {
          new_password: historyState.password,
        });
        // const updateUserProfilePromise = updateUserProfile(
        //   this.props.dispatch,
        //   { user: { display_name: historyState.displayName } },
        // );
        // await Promise.all([setPasswordPromise, updateUserProfilePromise]);
        await Promise.all([setPasswordPromise]);
      }
      this.setState({ doRedirect: true });
    } catch (e) {
      this.setState({ errors: e.message });
      console.log(e);
    }
  };

  disableForm = () => {
    this.setState({
      isDisabled: true,
    });
  };

  enableForm = () => {
    if(!this.state.disableVerify) {
      this.setState({
        isDisabled: false,
      });
    }
  };

  resendOtp = e => {
    e.preventDefault();
    if (this.state.disbleResendOtp) return;
    const { state: historyState } = this.props.location;
    cleverTap.event(AuthEvents.OTP_RESEND_CLICKED, {
      OTPChannel: this.props.forMobile ? 'Mobile' : 'Email',
      Type: historyState.newUser ? 'CreateAccount' : 'Login',
      Mobile: historyState.userMobile,
      Email: historyState.userEmail,
    });
    this.setState({ disbleResendOtp: true, errors: [] });
    setTimeout(() => this.setState({ disbleResendOtp: false }), 20000); // 20 secs
    sendOtp(this.props.dispatch, {
      ...this.params,
      additional_payload: {
        name: historyState.displayName,
      },
    });
  };

  render() {
    const { fetching: showLoader, success } = this.props.otpData;
    const buttonId = this.props.forMobile ? 'mobileOtpFilled' : 'emailOtpFilled';
    const resendButtonId = this.props.forMobile ? 'resendMobileOtp' : 'resendEmailOtp';
    const errors = this.props.otpData.error || this.state.errors;
    if (this.state.doRedirect) {
      return <Redirect to={this.getRedirectLocation()} />;
    }
    const { isDisabled, disbleResendOtp } = this.state;
    const btnClass = classNames({
      'dflt-btn pl-3 pr-3': true,
      'is-loading': showLoader,
      inactive: !showLoader && isDisabled,
    });
    const { state: { user, newUser } } = this.props.location;
    if (this.state.isLoading) {
      return (
        <div className="container">
          <h1 className="text-center pb-3">
            Sending OTP on {this.props.forMobile ? 'phone' : 'email'}
          </h1>
          <div className="otp-sub-header">{this.userEntity}</div>
          <Loader className="mt-4" width={80} height={80} />
        </div>
      );
    }
    const isEmailVerificationMandatory = !this.props.forMobile;
    const canUseDifferentMobile =
      this.props.forMobile &&
      !newUser &&
      user.mobile &&
      user.email &&
      !user.emailVerified;
    return (
      <div className="container">
        <h1 className="text-center">
          {isEmailVerificationMandatory
            ? 'Verify your email to update phone number'
            : this.props.pageHeading}
        </h1>
        <div className="otp-sub-header">
          {isEmailVerificationMandatory
            ? `Enter OTP sent to your email id ${this.userEntity}`
            : this.userEntity}
        </div>
        {canUseDifferentMobile && (
          <div className="text-center use-diff-mobile">
            <Link
              to={{
                pathname: '/account/set-mobile',
                state: this.props.location.state,
              }}
              className="resend-otp mt-0 mb-3"
              onClick={() =>
                cleverTap.event(AuthEvents.MOBILE_UPDATE_INITIATED, {
                  Email: user.email,
                  Phone: user.phone,
                })
              }
            >
              USE DIFFERENT PHONE
            </Link>
          </div>
        )}
        {React.Children.toArray(
          errors.map(err => <p className="error-message text-center">{userFriendlyErrorMessage(err)}</p>),
        )}
        <Form
          className="form-box landing-form-box"
          onSubmit={this.handleSubmit}
        >
          <div
            className={`form-group d-flex flex-column align-items-center ${
              this.state.error ? 'error' : ''
            }`}
          >
            <div>
              <label htmlFor="email">Enter OTP</label>
              <OtpInput
                ref={el => {
                  this.otpInputElement = el;
                }}
                wrapperClassName="d-flex justify-content-center"
                length={4}
                onOtpFilled={this.enableForm}
                onOtpNotFilled={this.disableForm}
              />
            </div>
          </div>
          <div className="pt-4 text-center">
            <Button type="submit" className={btnClass} id={buttonId}>
              {this.props.forMobile ? 'VERIFY MOBILE' : 'VERIFY EMAIL'}
            </Button>
            <div className="pt-1">
              <a href="#" className={`resend-otp ${disbleResendOtp ? 'resend-otp--disabled': ''}`} id={resendButtonId} onClick={this.resendOtp}>
                RESEND OTP
              </a>
            </div>
          </div>
        </Form>
        <p className="tnc">
          {' '}
          By proceeding I accept &nbsp;
          <a
            className="color"
            href={config.get('tncURL')}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
        </p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hubUser: state.session.hubUser,
    otpData: state.session.otpData,
  };
}

export default connect(mapStateToProps)(OTPVerify);
